declare var window: any;
declare var turnstile: any;

// Render Cloudflare Turnstile widget explicitly
// Reference: https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#explicit-rendering
// TODO: Move this to ColocatedHook once colocated hooks are enabled
const Turnstile = {
  mounted(this: any) {
    turnstile.render(this.el, {
      "error-callback": (errorCode: string) => {
        // On error, display error message and code
        const errorMsg = `Unable to render Cloudflare Turnstile. Error code: ${errorCode}`;
        console.error(errorMsg);
        const errorContainerId = this.el.dataset.errorContainerId;
        const errorContainer = document.getElementById(errorContainerId);
        if (errorContainer) errorContainer.innerText = errorMsg;
        // Return true to remove warning since it's already logged as an error.
        // See: https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/#error-handling
        return true;
      },
    });
  },
};

export default Turnstile;
